import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCargarMateriaSecaInsumo = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'carga_materia_seca',
        name: 'Cargar Materia Seca',
        component: ViewCargarMateriaSecaInsumo,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
